import { useEffect, useState } from "react";

import { useNavigate, useSearchParams } from "react-router-dom";

import ExitLearningModal from "../ExitLearningModal";

import InclusiveEducationVideo from "./InclusiveEducationVideo";

import { useGetInclusiveEducationContent } from "./queries";

import { CHAPTER_COMPLETE_PERCENTAGE, LMS_CHAPTER_ID, LMS_COURSE_ID, LMS_MODULE_ID } from "../../../../utils/cookiesmanager";

import InclusiveEducation from "./InclusiveEducation";
import { useSaveInclusiveContent } from "./mutation";

import styles from './styles.module.scss'

const InclusiveContent = () => {
  const [searchParams] = useSearchParams();

  const [showInclusiveContent, setShowShowInclusiveContent] = useState(false);
  const [allowLeave , setAllowLeave] = useState(false);
  const [showWarning ,setShowWarning] = useState(false);
  
  const navigate = useNavigate();
  
  const courseId = searchParams.get("courseId") || localStorage.getItem(LMS_COURSE_ID) ;
  const chapterId = searchParams.get("chapterId") || localStorage.getItem(LMS_CHAPTER_ID);
  const moduleId = searchParams.get("moduleId") || localStorage.getItem(LMS_MODULE_ID);

  const languageId = localStorage.getItem("l_id") || 1;

  const { data: inclusiveEducationContent, isLoading } =
    useGetInclusiveEducationContent({
      chapterId,
      courseId,
      languageId,
      moduleId,
    });

    const { response } = inclusiveEducationContent?.data || {};

  const videoData = response?.videos?.[0];

  const videoStatus = videoData?.videoStatus;

    const totalParts = inclusiveEducationContent?.data?.response?.totalContent;

   const { mutate: saveProgress , isPending } =
    useSaveInclusiveContent();

    useEffect(() => {
        // Add a dummy history entry
        window.history.pushState({ guard: true }, "", `${window.location.pathname}?${searchParams.toString()}`);
    
        const handlePopState = () => {
          if (!allowLeave) {
            setShowWarning(true);
    
            // Re-push state to stop navigation
            window.history.pushState(
              { guard: true },
              "",
              window.location.pathname
            );
          }
        };
    
        window.addEventListener("popstate", handlePopState);
    
        return () => {
          window.removeEventListener("popstate", handlePopState);
        };
    },[allowLeave])

    const handleBackClick = () => {
     setShowWarning(true);
    }

    const handleContinueLearning = () => {
        setShowWarning(false)
        setAllowLeave(false)
    }

    const handleExit = () => {
    navigate(`/user/chapter-list?courseId=${courseId}&moduleId=${moduleId}`)
    }

  const handleContinue = () => {
     if(videoStatus === 1){
      setShowShowInclusiveContent(true);
      return;
    }

    saveProgress(
      {
        courseId,
        moduleId,
        chapterId,
        totalParts: totalParts || 1,
        part: 1,
      },
      {
        onSuccess: () => {
          setShowShowInclusiveContent(true);
        },
        onError: (error) => {
          console.error("Progress update failed", error);
        },
      },
    );
  };

  return (
    <div className={styles['inclusive-content']}>
      {showInclusiveContent ? (
        <InclusiveEducation
          inclusiveEducationContent={inclusiveEducationContent}
          handleContinueLearning={handleContinueLearning}
          handleBackClick={handleBackClick}
          isLoading={isLoading}
        />
      ) : (
        <InclusiveEducationVideo
          inclusiveEducationContent={inclusiveEducationContent}
          isLoading={isLoading}
          handleClick={handleContinue}
          handleContinueLearning={handleContinueLearning}
          handleBackClick={handleBackClick}
          isPending={isPending}
        />
      )}
      {showWarning && <ExitLearningModal handleContinueLearning={handleContinueLearning}  handleExit={handleExit} show={showWarning}/>}
    </div>
  );
};

export default InclusiveContent;
